import $ from "jquery";
import { addressFormatter } from "../framework/addressFormatter";
import { dataaccess } from "../dataaccess/dataContext";
import { countryState } from "./countryState";
import intlTelInput from 'intl-tel-input';

let isEditing = false;
const originalValues = [];
let isIniting = false;
let itiDisplayPhone = {};
let itiPhone = {};
let itiDisplayFax = {};
let itiFax = {};

function init() {
    itiDisplayPhone = intlTelInput(document.querySelector("#displayPhoneNumber"), { utilsScript: "/dist/utils.js", autoPlaceholder: "none" });
    itiDisplayFax = intlTelInput(document.querySelector("#displayFaxNumber"), { utilsScript: "/dist/utils.js", autoPlaceholder: "none" });
    itiPhone = intlTelInput(document.querySelector("#txtEditPhoneNumber"), { utilsScript: "/dist/utils.js", autoPlaceholder: "aggressive" });
    itiFax = intlTelInput(document.querySelector("#txtFax"), { utilsScript: "/dist/utils.js", autoPlaceholder: "aggressive" });

    var phoneCountry = $("#txtSelectedCountry").val();
    if ($("#txtSelectedCountry").val() == "UK") {
        phoneCountry = "GB";
    }

    if ($("#txtEditPhoneNumber").val() === "") {
        itiDisplayPhone.setCountry(phoneCountry);
        itiPhone.setCountry(phoneCountry);
    }

    if ($("#txtFax").val() === "") {
        itiDisplayFax.setCountry(phoneCountry);
        itiFax.setCountry(phoneCountry);
    }
    countryState
        .populateCountriesSelect("#ddlEditPersonCountry", "#divEditNaState")
        .done(function () {
            const selectedCountry = $("#txtSelectedCountry").val();
            countryState.populateStatesSelect("#divEditNaState", "#divEditNonNaState", selectedCountry);
            //addressFormatter.maskPhone($("#txtEditPhoneNumber, #txtFax"), selectedCountry);
            addressFormatter.maskZip($("#txtEditPostalCode"), selectedCountry);
            addressFormatter.showIfUsOrCa($("#NaPostalReq, #NaStateReq"), selectedCountry);

            if (addressFormatter.isUsOrCa(selectedCountry)) {
                $("#txtNonNaState").val("");
            }
            $("#selectPersonState").val($("#txtSelectedStateId").val());
            const regionid = $("#hdnSelectedRegionId").val();
            $("#txtRegionId").val(regionid);
            loadAreas(regionid);
            $("#selectArea").val($("#hdnSelectedAreaId").val());
            builderOriginalFormValues();

            setEvents();
        });
}

function setEvents() {
    $("#chkMilitary").on("change", function () {
        calculateRegionId();
    });

    $("#selectPersonState").change(function () {
        calculateRegionId();
    });

    $("#ddlEditPersonCountry").change(countrySelectionChanged);
    $("#btnBasicInfoEdit").click(toggleEditBasicInfo);
    $("#btnCancelEdit").click(cancelEdit);
    $("#btnSaveEdit").click(validateAndSubmitForm);
    $(document).on("change", "#txtEditPhoneNumber", function () {
        $("#validationPhoneSpan").addClass("hidden");
        if ($("#txtEditPhoneNumber").val().trim() !== "" && !itiPhone.isValidNumber()) {
            $("#validationPhoneSpan").removeClass("hidden");
        }
    });
    $(document).on("change", "#txFax", function () {
        $("#validationFaxSpan").addClass("hidden");
        if ($("#txtFax").val().trim() !== "" && !itiFax.isValidNumber()) {
            $("#validationFaxSpan").removeClass("hidden");
        }
    });
}

function validateAndSubmitForm() {
    $("#arearequiredspan").addClass("hidden");
    const $form = $(this).closest("form");

    if (!$form.valid()) {
        return;
    }

    if ($("#txtEditPhoneNumber").val().trim() !== "" && !itiPhone.isValidNumber()) {
        $("#validationPhoneSpan").removeClass("hidden");
        return;
    }

    if ($("#txtFax").val().trim() !== "" && !itiFax.isValidNumber()) {
        $("#validationFaxSpan").removeClass("hidden");
        return;
    }

    if ($("#selectArea option").length > 1) {
        if ($("#selectArea").val() < 1) {
            $("#arearequiredspan").removeClass("hidden");
            return;
        }
    }

    $("#txtEditPhoneNumber").val(itiPhone.getNumber());
    $("#txtFax").val(itiFax.getNumber());

    $form.submit();
}

function toggleEditBasicInfo() {
    const isAcsMember = $("#isAcsMember").val();
    if (!isEditing) {
        $("#editIcon")
            .removeClass("fa-pen")
            .addClass("fa-times");
        $("#divPersonalDetails [js-readonly]").hide();
        $("#divCancelSaveBtns, [edit]").removeClass("hidden");
        if (isAcsMember === "True") {
            $("#divPersonalDetails [js-member-readonly]").show();
            $("[js-member-nonedit]").prop("readonly", true);
            $("[js-member-hide]").addClass("hidden");
        }
        $("#divPersonalDetails input[type=checkbox]").attr("disabled", false);
        $("#divPersonalDetails input[type=radio]").each(function () { $(this).attr("disabled", false); });
        resetValues();
        itiDisplayPhone.setNumber($("#txtEditPhoneNumber").val());
        itiPhone.setNumber($("#txtEditPhoneNumber").val());
        $("#validationPhoneSpan").addClass("hidden");
        itiDisplayFax.setNumber($("#txtFax").val());
        itiFax.setNumber($("#txtFax").val());
        $("#validationFaxSpan").addClass("hidden");
    } else {
        $("#editIcon")
            .removeClass("fa-times")
            .addClass("fa-pen");
        $("#divPersonalDetails [js-readonly]").show();
        $("#divCancelSaveBtns, [edit]").addClass("hidden");
        $("#divPersonalDetails input[type=checkbox]").attr("disabled", true);
        $("#divPersonalDetails input[type=radio]").each(function () { $(this).attr("disabled", true); });
        isIniting = true;
        countrySelectionChanged();
        isIniting = false;
        loadAreas($("#hdnSelectedRegionId").val());
    }
    isEditing = !isEditing;
}
//If they edit it and click cancel we need to revert it to the model values so they are being saved here.
function builderOriginalFormValues() {
    $("#divPersonalDetails")
        .find(":input:not([type='hidden'])")
        .each(function () {
            originalValues.push({
                id: $(this).attr("id"),
                value: $(this).is(":checkbox") ? $(this).is(":checked") : $(this).val(),
                type: $(this).attr("type") || $(this)[0].tagName
            });
        });
}

function cancelEdit() {
    toggleEditBasicInfo();
}

function countrySelectionChanged() {
    const selectedCountry = $("#ddlEditPersonCountry").val();
    itiPhone.setCountry(selectedCountry);
    itiFax.setCountry(selectedCountry);
    $("#txtSelectedCountry").val(selectedCountry);
    countryState.populateStatesSelect("#divEditNaState", "#divEditNonNaState", selectedCountry);
    addressFormatter.maskPhone($("#txtEditPhoneNumber, #txtFax"), selectedCountry);
    addressFormatter.maskZip($("#txtEditPostalCode"), selectedCountry);
    addressFormatter.showIfUsOrCa($("#NaPostalReq, #NaStateReq"), selectedCountry);

    if (addressFormatter.isUsOrCa(selectedCountry)) {
        $("#txtNonNaState").val("");
    }
    if (!isIniting) {
        calculateRegionId();
    }
}

function resetValues() {
    for (let i = 0; i < originalValues.length; i++) {
        switch (originalValues[i].type.toLowerCase()) {
            case "email":
            case "select":
            case "text":
                $("#" + originalValues[i].id).val(originalValues[i].value);
                break;
            case "tel":
                $("#" + originalValues[i].id).val(originalValues[i].value);
                break;
            case "checkbox":
                $("#" + originalValues[i].id).prop("checked", originalValues[i].value);
                break;
        }
    }
    setSelectedArea($("#hdnSelectedAreaId").val());
    setSelectedCountry($("#txtSelectedCountry").val());
    countryState.populateStatesSelect(
        "#divEditNaState",
        "#divEditNonNaState",
        $("#ddlEditPersonCountry").val()
    );
    $("#selectPersonState").val($("#txtSelectedStateId").val());
}

function setSelectedCountry(selectedCountry) {
    $("#ddlEditPersonCountry").val(selectedCountry);
}

function setSelectedArea(selectedArea) {
    $("#selectArea").val(selectedArea);
}

function calculateRegionId() {
    const militaryValue = $("#chkMilitary").is(":checked");
    const countryCodeValue = $("#ddlEditPersonCountry").val();
    if (countryCodeValue === "") {
        return;
    }
    let stateIdValue = $("#selectPersonState").val();
    if (stateIdValue === "") {
        stateIdValue = "0";
    }
    dataaccess
        .get({
            url:
                "/api/region/GetRegionId/" + militaryValue + "/" + countryCodeValue + "/" + stateIdValue
        })
        .done(function (result) {
            $("#hdnSelectedRegionId").val(result);
            $("#txtRegionId").val(result);
            loadAreas(result);
        })
        .fail(function () {
            $("#hdnSelectedRegionId").val(0);
            $("#txtRegionId").val("error");
        });
}

function loadAreas(regionId) {
    $("#arearequiredspan").addClass("hidden");
    const countryCodeValue = $("#txtSelectedCountry").val();
    if (countryCodeValue === "") {
        return;
    }
    let stateIdValue = $("#selectPersonState").val();
    if (stateIdValue === "") {
        stateIdValue = "0";
    }
    $("#selectArea").find("option").not(":first").remove().end();
    dataaccess
        .get({
            url:
                "/api/Area/GetAreasForRegionId/" + regionId + "/" + countryCodeValue + "/" + stateIdValue
        })
        .done(function (results) {
            for (let i = 0; i < results.length; i++) {
                if (results[i].selected === true) {
                    $("#selectArea").append("<option value='" + results[i].areaId + "' selected>" + results[i].areaName + "</option>");
                } else {
                    $("#selectArea").append("<option value='" + results[i].areaId + "'>" + results[i].areaName + "</option>");
                }
            }
        })
        .fail(function () {
            $("#selectArea").append("<option value='" + 0 + "'>" + "Error Getting Areas" + "</option>");
        });
}

export const personBasicInfo = {
    init: init
};
